import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import './App.css';
import Loading from './Loading';
import Dashboard from './Dashboard';
import Location from './Location';
import Translator from './Translator';
import Nearme from './Nearme';
import Foodapps from './Foodapps';
import Currency from './Currency';
import Settings from './Settings';
import Emergency from './Emergency';
import { useEffect, useState } from 'react';

function Page404() {
  return (
    <>
      <h1>No Page Found</h1>
    </>
  )
}

function App() {

  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "dark";
    setTheme(savedTheme);

    document.body.className = savedTheme;
  }, []);

  return (
    <Router>
      <Routes>
        <Route path='*' element={<Page404 />} />
        <Route path='/' element={<Loading />} />
        <Route path='/Dashboard' element={<Dashboard />} ></Route>
        <Route path='/Location' element={<Location />} ></Route>
        <Route path='/Translator' element={<Translator />} ></Route>
        <Route path='/Nearme' element={<Nearme />} ></Route>
        <Route path='/Foodapps' element={<Foodapps />} ></Route>
        <Route path='/Currency' element={<Currency />} ></Route>
        <Route path='/Emergency' element={<Emergency />}></Route>
        <Route path='/Settings' element={<Settings />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
